import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { RouteGuardService } from './guard/route-guard.service';
import { UtentiService } from './services/utenti.service';

import { AuthService } from './services/auth.service';
import { bearerToken } from './app.module';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OpzioniService } from './services/opzioni.service';
import { QRCodeService } from './services/qrcode.service';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { SocketioService } from './services/socketio.service';
import dayjs from 'dayjs';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(
    public guard: RouteGuardService,
    private router: Router,
    private uSvc: UtentiService,
    private authSvc: AuthService,
    private opzSvc: OpzioniService,
    private qrSvc: QRCodeService,
    private keycloak: KeycloakService,
    private socketioService: SocketioService,
  ) {}

  ngOnInit(): void {
    bearerToken.pipe(untilDestroyed(this)).subscribe(token => {
      this.authSvc.setBearerToken(token);
      //this.socketioService.updateToken(token);
      console.log('Keycloak authentication successful.');
      const exp = this.keycloak.getKeycloakInstance().tokenParsed.exp;
      const refreshIn = new Date(exp * 1000).getTime() - Date.now() - 20000;
      setTimeout(() => {
        this.keycloak.updateToken(25)
        .then(refreshed => {
          if (refreshed) {
            this.keycloak.getToken().then(token => {
              const data = dayjs().format('YYYY-MM-DD HH:mm:ss');
              console.log(`Keycloak token refreshed successfully at ${data}:`, token);
              bearerToken.next(token);
            });
          }
        })
        .catch(error => {
          console.error('Keycloak: Error refreshing token after expiry:', error);
          // Handle critical refresh failure: redirect to login
          this.keycloak.login(); // Force re-login
        });
      }, refreshIn);
    });

    /* this.keycloak.keycloakEvents$.subscribe({
      next: (event) => {
        console.log('Keycloak event received:', event);
        if (event.type === KeycloakEventType.OnAuthSuccess) {
          console.log('Keycloak authentication successful.');
          const exp = this.keycloak.getKeycloakInstance().tokenParsed.exp;
          const refreshIn = new Date(exp * 1000).getTime() - Date.now() - 20000;
          setTimeout(() => {
            this.keycloak.updateToken(25)
            .then(refreshed => {
              if (refreshed) {
                this.keycloak.getToken().then(token => {
                  const data = dayjs().format('YYYY-MM-DD HH:mm:ss');
                  console.log(`Keycloak token refreshed successfully at ${data}:`, token);
                  bearerToken.next(token);
                });
              }
            })
            .catch(error => {
              console.error('Keycloak: Error refreshing token after expiry:', error);
              // Handle critical refresh failure: redirect to login
              this.keycloak.login(); // Force re-login
            });
          }, refreshIn);
        }
      },
    }); */

    

    const temaDefault = 'teom';
    this.opzSvc.getTemaWebapp().then(tema => {
      this.caricaTema('tema-grafico-custom', tema);
      // carico anche il tema di default, che sarà inserito *prima*
      // di quello custom, quindi meno prioritario.
      // In questo modo nel tema custom se voglio posso definire solo
      // alcune variabili e quelle mancanti saranno prese dal tema di
      // default
      this.caricaTema('tema-grafico-default', temaDefault);
      this.impostaIcona(tema);
    }).catch(err => {
      console.error(err);
      // in caso di problemi carico comunque il tema di default
      this.caricaTema('tema-grafico-default', temaDefault);
      this.impostaIcona(temaDefault);
    });
  }

  async onLogout() {
    this.uSvc.onLogout(); // cancella il sessionId da sessionStorage
    await this.guard.logout();
    this.authSvc.setBearerToken(undefined);
    this.authSvc.setIdUtenteLoggato(undefined);
    this.router.navigateByUrl('/');
  }

  caricaTema(linkId: string, tema: string) {
    this.aggiungiOModificaLink(linkId, tema, 'stylesheet', 'text/css', 'style.css');
  }

  aggiungiOModificaLink(linkId: string, tema: string, rel: string, type: string, hrefFile: string) {
    let link = document.getElementById(linkId) as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = rel;
      link.type = type;

      const head = document.getElementsByTagName('head')[0];
      head.prepend(link);
    }

    link.href = `assets/temi/${tema}/${hrefFile}`;
  }

  impostaIcona(tema: string) {
    this.aggiungiOModificaLink('favicon-link', tema, 'icon', 'image/png', 'favicon.png');
  }


}
